module.exports = __webpack_public_path__ + "static/media/peterkleinjan.be79553f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/peterkleinjan.webp
// module id = 680
// module chunks = 0